<template>
   <div class="carDialog tender-contract">
       <el-dialog
        class="form-dialog row-dialog"
        title="预警配置"
        :visible="RwCarVisiable"
        :close-on-click-modal="false"
        :before-close="handleRwCarClose"
        width="65%"
    >
         <el-form :model="form" label-width="80px" class="wrapper-form" :rules="rules" ref="form">
              <el-form-item class="item" label="业务类型" prop="businessType">
          <MSelect
            style="width: 100%;"
            :optionNum="'BID_BUSINESS_TYPE'"
            :value="form.businessType"
            :filterable="true"
            @input="getLowerLastRoundbt"
          ></MSelect>
        </el-form-item>
           <el-form-item class="item" label="预警天数" prop="warnDays">
          <MSelect
            style="width: 100%;"
            :optionNum="'SRM_CONTRACT_WARN_DAYS'"
            :value="form.warnDays"
            :filterable="true"
            @input="getLowerLastRoundwd"
          ></MSelect>
        </el-form-item>
        <el-form-item class="item" label="分公司" prop="companyName">
          <el-input  placeholder="请输入内容" v-model="form.companyName" clearable style="width: 100%;">
            <el-button slot="append" icon="el-icon-search" @click="detail(companyNameData,'companyName')"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item class="item" label="服务平台" prop="siteName">
          <el-input placeholder="请输入内容" v-model="form.siteName" clearable >
            <el-button slot="append" icon="el-icon-search" @click="detail(siteNameData,'siteName')"></el-button>
          </el-input>
        </el-form-item>
           <el-form-item class="item" label="发送人员" prop="sendAccountName">
          <el-input placeholder="请输入内容" v-model="form.sendAccountName" clearable style="width: 100%;">
            <el-button slot="append" icon="el-icon-search"  @click="detailOrganizerName()"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
        <div slot="footer">
            <el-button @click="handleRwCarClose">取 消</el-button>
            <el-button type="primary" :loading="saveLoading" :disabled="isButtonDisabled"
            @click="AdmittOk('form')">保 存</el-button>
        </div>
    </el-dialog>
    <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
        <groupDialog
      :checkPerStatus="openPerDialog"
      @perDialog="overPerDialog"
      @closePerDialog="closePerDialog"
      v-if="openPerDialog.showDialog"
    ></groupDialog>

   </div>
</template>

<script>
import MSelect from '@/components/lots/otpSelect2';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import groupDialog from '../personOne/groupDialog';

export default {
    components: {
        advanceDialog, MSelect, groupDialog
    },
    props: {
        RwCarVisiable: {
            type: Boolean,
            default: false
        },
        dataLists: {
            type: Object,
            default() {
                return {};
            }
        },
        isButtonDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            saveLoading: false,
            dialogStatus: false,
            form: {
                id: '',
                businessType: '',
                warnDays: '',
                companyName: '',
                siteName: '',
                sendAccountName: '',
                version: '',
                status: ''
            },
            // 组织者
            openPerDialog: {
                openIndex: 0,
                showDialog: false,
                checkedList: []
            },
            rules: {
                businessType: [{ required: true, message: ' ', trigger: 'blur' }],
                warnDays: [{ required: true, message: ' ', trigger: 'blur' }],
                companyName: [{ required: true, message: ' ', trigger: 'blur' }],
                sendPosition: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            // 分公司
            companyNameData: {
                advanceConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' }
                ],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                name: '分公司',
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' }
                ]
            },
            // 服务平台
            siteNameData: {
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                advancePrefix: 'web-bms',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                name: '服务平台',
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ]
            }
        };
    },
    methods: {
        detail(current, dialogStatus) {
            this.dialogStatus = dialogStatus;
            const advanceCascade = {};
            if (
                current.advanceCascade &&
        Object.prototype.toString.call(current.advanceCascade) ===
          '[object String]'
            ) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map(item => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade);
        },
        getLowerLastRoundbt(val) {
            this.form.businessType = val;
        },
        getLowerLastRoundwd(val) {
            this.form.warnDays = val;
        },
        // 组织者
        detailOrganizerName() {
            this.openPerDialog.showDialog = true;
        },
        closePerDialog(data) {
            this.openPerDialog.showDialog = data.open;
        },
        overPerDialog(data) {
            this.openPerDialog.showDialog = data.open;
            this.form.sendAccountName = data.checklist[0].userName;
            this.form.sendAccountCode = data.checklist[0].userCode;
        },
        detaliSearchSure(data) {
            if (this.dialogStatus === 'companyName') {
                this.form.companyCode = data.companyCode;
            } else if (this.dialogStatus === 'siteName') {
                this.form.siteCode = data.siteCode;
            }
            this.form[this.dialogStatus] = data[this.dialogStatus];
        },
        handleRwCarClose() {
            this.$emit('update:RwCarVisiable', false);
        },
        AdmittOk(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit('AdmittOk', this.form);
                } else {
                    return false;
                }
            });
        }
    },
    mounted() {

    },
    created() {
        Object.keys(this.form).forEach(item => {
            Object.keys(this.dataLists).forEach(key => {
                if (item === key) {
                    this.form[item] = this.dataLists[key];
                }
            });
        });
    }
};
</script>

<style lang="less">
// @import './carSchedulingDialog.less';
.tender-contract {
  flex-direction: column;
  display: flex;
  flex: 1 auto;
  padding: 16px;
  background-color: #fff;
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 700;
  }
  .el-form-item__content {
    height: 33px;
  }
  .wrapper-form {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      width: 23%;
      height: 35px;
      margin-bottom: 5px;
    }
  }
  .bottom {
    margin-top: 20px;
    padding-bottom: 20px;
  }
  .contract-center {
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 20px;
    .top {
      margin-top: 15px;
      display: flex;
    }
  }
  .contract-bottom {
    margin-top: 15px;
    width: 100%;
    display: flex;
    .contract-flie {
      width: 665px;
      margin-right: 60px;
    }
    .flie-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .exampleStyle {
      font-size: 12px;
      font-weight: 100;
      color: #333;
      line-height: 19px;
      margin-left: 10px;
    }
    .flie-top-right {
      display: flex;
      align-items: center;
      div {
        cursor: pointer;
      }
    }
    .el-icon-upload2 {
      color: #00bcbf;
      margin-right: 5px;
    }
    .load-info {
      font-size: 13px;
      margin-right: 10px;
    }
    .top-info {
      font-size: 14px;
      margin: 0;
    }
    .el-button {
      width: 80px;
      height: 28px;
    }
    .el-table--border {
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }
  }
  .el-row {
    border: 1px solid red;
  }
  .el-input {
    margin-bottom: 10px;
  }
}
</style>